import { render, staticRenderFns } from "./OpeningBalances.vue?vue&type=template&id=67c7d5fb&scoped=true"
import script from "./OpeningBalances.vue?vue&type=script&lang=js"
export * from "./OpeningBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7d5fb",
  null
  
)

export default component.exports